import { generateAuthHeader } from "../../../commonfunctions/authentication";
import type { CurrentOrder } from "../../../redux/reducers/orders";

export interface CurrentOrderResponse {
  status: number;
  message: string;
  order: CurrentOrder | null;
}

const getCurrentOrder = async (): Promise<CurrentOrderResponse> => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_HALFBACK_ROOT_API}/orders/current_order`,
      generateAuthHeader(),
    );
    if (!res.ok) throw new Error("Failed to fetch current order");
    const data: CurrentOrder = await res.json();
    return { status: 200, message: "ok", order: data };
  } catch (error) {
    return { status: 500, message: "Failed to get current order", order: null };
  }
};

export default getCurrentOrder;
